// extracted by mini-css-extract-plugin
module.exports = {"container":"ta-z"};